<template>
    <div class="container mescroll-touch">
        <div class="topdh" @click="back"><img src="../../assets/images/bjback.png" class="homeimg" />首页&nbsp;>&nbsp;{{
            Name }}
        </div>
        <div class="total">
            <!-- <img src="../../assets/images/bjtitle2.png" class="img" /> -->
            <div class="textarea" v-html="htmlinner"></div>
            <!-- <img src="../../assets/images/bjwel.jpg" class="mainimg" alt="" /> -->
            <!-- <img src="../../assets/images/bjfooter.png" class="footerimg" /> -->
        </div>
        <div class="backbtn" @click="back()">
            <img src="../../assets/images/backicon.png" alt="">
        </div>
    </div>
</template>

<script>
import mixin from '../../common/mixin/mixins'
export default {
    name: 'customtextarea',
    data() {
        return {
            htmlinner: '',
            Name: this.$route.query.Name,
        }
    },
    mixins: [mixin],
    created() {
        this.getinfo();
        this.getmod();
        document.title = this.$route.query.Title;
    },
    mounted() {
        this.initDrag();
    },
    methods: {
        getmod() {
            let that = this
            this.$axios
                .get("/api/api/web/Activity/GetModel?id=" + this.$route.query.ActivityId)
                .then((res) => {
                    that.meetinginfo = res.Data
                    this.initzqShare(that.meetinginfo.ForwardMainTitle, this.$route.query.Name, that.meetinginfo.ForwardPic);
                });
        },
        getinfo() {
            let that = this;
            this.$axios.get('/api/api/web/Activity/GetModuleModel?id=' + this.$route.query.Id).then(res => {
                if (res.RetCode == "10000") {
                    // console.log(res.Data)
                    that.htmlinner = res.Data.Description
                }
            });
        },
        back() {
            this.$router.replace({
                path: "custom",
                query: {
                    Id: this.$route.query.ActivityId,
                },
            });
        },
        initDrag() {
            const btn = document.querySelector('.backbtn');
            if (!btn) return;

            // 触摸开始（移动端）
            btn.addEventListener('touchstart', (e) => {
                this.isDragging = true;
                // 获取初始触摸位置
                this.startX = e.touches[0].clientX;
                this.startY = e.touches[0].clientY;
                // 获取按钮当前位置
                const rect = btn.getBoundingClientRect();
                this.btnX = rect.left;
                this.btnY = rect.top;
                // 阻止默认行为
                // e.preventDefault();
            });

            // 触摸移动（移动端）
            btn.addEventListener('touchmove', (e) => {
                if (!this.isDragging) return;
                // 计算移动距离
                const moveX = e.touches[0].clientX - this.startX;
                const moveY = e.touches[0].clientY - this.startY;
                // 设置按钮新位置
                btn.style.left = `${this.btnX + moveX}px`;
                btn.style.top = `${this.btnY + moveY}px`;
                // 清除原有right/transform
                btn.style.right = 'auto';
                btn.style.transform = 'none';
                e.preventDefault();
            });

            // 触摸结束（移动端）
            btn.addEventListener('touchend', () => {
                this.isDragging = false;
            });

            // 兼容PC端鼠标操作
            btn.addEventListener('mousedown', (e) => {
                this.isDragging = true;
                this.startX = e.clientX;
                this.startY = e.clientY;
                const rect = btn.getBoundingClientRect();
                this.btnX = rect.left;
                this.btnY = rect.top;
                e.preventDefault();
            });

            document.addEventListener('mousemove', (e) => {
                if (!this.isDragging) return;
                const moveX = e.clientX - this.startX;
                const moveY = e.clientY - this.startY;
                btn.style.left = `${this.btnX + moveX}px`;
                btn.style.top = `${this.btnY + moveY}px`;
                btn.style.right = 'auto';
                btn.style.transform = 'none';
            });

            document.addEventListener('mouseup', () => {
                this.isDragging = false;
            });
        }
    }
}
</script>

<style lang="scss" scoped>
body {
    -webkit-overflow-scrolling: unset
}

.container {
    height: 100%;
    width: 100%;
    position: relative;
    -webkit-overflow-scrolling: unset // background: rgb(228, 236, 255);
}

.total {
    position: relative;
    height: 100%;
    padding: 0 .5rem;
    padding-top: .3rem;
}

.img {
    display: block;
    width: 100%;
    margin-bottom: .2rem
}

.guanggaoimg {
    display: block;
    width: 90%;
    margin: 0.5rem auto;
}

.footerimg {
    display: block;
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 1;
}

.topdh {
    font-family: cursive;
    font-weight: bold;
    background: #003583;
    color: #fff;
    padding: 0.3rem;
}

.homeimg {
    width: 5%;
    display: inline-block;
    vertical-align: text-bottom;
    margin-right: 0.1rem;
}

.mainimg {
    width: 100%;
    position: relative;
    z-index: 100;
    margin-bottom: 1.8rem;
}

.backbtn {
    width: 13%;
    position: fixed;
    right: 0;
    top: 50%;
    opacity: .8;
    transform: translateY(-50%);
    z-index: 99999;
    /* 新增拖动相关样式 */
    touch-action: none;
    /* 禁用浏览器默认触摸行为 */
    user-select: none;
    /* 防止拖动时选中文字 */
    -webkit-user-drag: element;
    /* 开启移动端拖动 */
    cursor: move;
    /* 鼠标指针提示可拖动 */
    transition: transform 0.1s ease;
    /* 拖动过渡更顺滑 */
}

.backbtn:active {
    opacity: 1;
    /* 拖动时提高透明度，增强反馈 */
    transform: translateY(-50%) scale(1.05);
    /* 拖动时轻微放大，提升体验 */
}

.backbtn img {
    width: 100%;
    pointer-events: none;
    /* 让拖动事件穿透到父元素 */
}
</style>